import React, { useEffect, useState } from 'react';
import useAuth from 'src/hooks/useAuth';
import PlanService from 'src/services/Plan.service';
import BrandAutocomplete, { createOptionsFromArr } from '.';

function PlanAutocomplete({
  onChange,
  value,
  name,
  label,
  pickKey,
  multiple = false,
  noLabel,
  filter = {},
  disabled,
  required = false
}) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await PlanService.get({
        ...filter,
        page: 0,
        pageSize: 0
      });

      const { data: plans = [] } = data || {};

      setOptions(plans);
    })();
  }, [JSON.stringify(filter)]);

  return (
    <BrandAutocomplete
      required={required}
      label={label}
      noLabel={noLabel}
      placeholder="Select plan..."
      onChange={onChange}
      value={value}
      multiple={multiple}
      name={name ?? 'plan'}
      disabled={disabled}
      options={createOptionsFromArr(options, 'name', pickKey || 'id')}
    />
  );
}

export default PlanAutocomplete;
